import React from "react";
import { ControlledCustomSelect, CustomSelect } from "../../../formsComponents";
import { IDateFilterDropdownProps } from "./interfaces/IDateFilterDropdownProps";
import { MenuItem } from "@mui/material";

export const DateFilterDropdown: React.FC<IDateFilterDropdownProps> = (
	props
) => {
	const {
		value,
		options,
		sx,
		onChange,
		label,
		displayEmpty,
		placeholder,
		fullWidth,
	} = props;

	return (
		<ControlledCustomSelect
			sx={{ minWidth: "120px", ...sx }}
			value={value}
			label={label}
			onChange={onChange}
			fullWidth={fullWidth}
			displayEmpty={displayEmpty}
			placeholder={placeholder}
			options={options}
		></ControlledCustomSelect>
	);
};
